import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React from 'react';
import { Input, Button, Transition, Grid, Sticky } from 'semantic-ui-react';
import Image from '../../../atoms/Image';
import { useRecaptcha } from '../../../components/RecaptchaProvider/RecaptchaProvider.hooks';
import { EmailCaptureButtonPropType, EmailCaptureFieldsPropType } from '../EmailCapture.propTypes';
import NoFormInputs from '../components/NoFormInputs';
import closebtnImg from '../assets/closebtn.png';
import closebtnDarkImg from '../assets/closebtnDark.png';
var defaultProps = {
  isSuccess: false,
  isSubmitting: false,
  formFieldValues: {},
  errors: {},
  darkCloseBtn: true
};
export default function Banner(props) {
  var _useRecaptcha = useRecaptcha(),
    _useRecaptcha2 = _slicedToArray(_useRecaptcha, 2),
    recaptchaLoaded = _useRecaptcha2[1];
  var description = props.description,
    bgColor = props.bgColor,
    descriptionTextColor = props.descriptionTextColor,
    button = props.button,
    submitForm = props.submitForm,
    closeEmailCapture = props.closeEmailCapture,
    isVisible = props.isVisible,
    isSubmitting = props.isSubmitting,
    isSuccess = props.isSuccess,
    updateFormFields = props.updateFormFields,
    fields = props.fields,
    formFieldValues = props.formFieldValues,
    errors = props.errors,
    darkCloseBtn = props.darkCloseBtn;
  var _fields$ = fields[0],
    inputKey = _fields$.key,
    label = _fields$.label; // Banner only uses first field
  var value = formFieldValues[inputKey] || '';
  var errorMsg = errors[inputKey];
  return /*#__PURE__*/React.createElement(Transition, {
    visible: isVisible,
    animation: "slide down",
    unmountOnHide: true
  }, /*#__PURE__*/React.createElement(Sticky, {
    active: true
  }, /*#__PURE__*/React.createElement(Grid, {
    style: {
      backgroundColor: bgColor
    },
    verticalAlign: "middle",
    className: "emailcapture-banner"
  }, /*#__PURE__*/React.createElement(Grid.Column, {
    computer: "2",
    tablet: "1",
    only: "computer tablet"
  }), /*#__PURE__*/React.createElement(Grid.Column, {
    computer: "12",
    tablet: "13",
    only: "computer tablet",
    className: "emailcapture-banner-col"
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      color: descriptionTextColor
    }
  }, description), isSuccess && /*#__PURE__*/React.createElement(NoFormInputs, null), !isSuccess && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", null, errorMsg && /*#__PURE__*/React.createElement("p", {
    className: "emailcapture-form-input-error",
    style: {
      color: descriptionTextColor
    }
  }, errorMsg), /*#__PURE__*/React.createElement(Input, {
    error: errorMsg,
    placeholder: label,
    onChange: function onChange(event) {
      return updateFormFields(inputKey, event);
    },
    value: value
  })), /*#__PURE__*/React.createElement(Button, {
    loading: isSubmitting,
    onClick: submitForm,
    style: {
      backgroundColor: button.bgColor,
      color: button.textColor
    }
  }, button.label))), /*#__PURE__*/React.createElement(Grid.Column, {
    computer: "2",
    tablet: "2",
    only: "computer tablet",
    className: "emailcapture-banner-close"
  }, /*#__PURE__*/React.createElement(Image, {
    as: "a",
    src: darkCloseBtn ? closebtnDarkImg : closebtnImg,
    onClick: closeEmailCapture
  })), /*#__PURE__*/React.createElement(Grid.Column, {
    mobile: "13",
    only: "mobile",
    className: "emailcapture-banner-col"
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      color: descriptionTextColor,
      textAlign: 'center'
    }
  }, description)), /*#__PURE__*/React.createElement(Grid.Column, {
    mobile: "3",
    only: "mobile",
    className: "emailcapture-banner-close"
  }, /*#__PURE__*/React.createElement(Image, {
    as: "a",
    src: darkCloseBtn ? closebtnDarkImg : closebtnImg,
    onClick: closeEmailCapture
  })), /*#__PURE__*/React.createElement(Grid.Column, {
    mobile: "16",
    only: "mobile",
    className: "emailcapture-banner-col"
  }, /*#__PURE__*/React.createElement(Input, {
    placeholder: label,
    onChange: function onChange(event) {
      return updateFormFields(inputKey, event);
    },
    value: value
  }), /*#__PURE__*/React.createElement(Button, {
    loading: isSubmitting,
    disabled: isSubmitting || !recaptchaLoaded,
    onClick: submitForm,
    style: {
      backgroundColor: button.bgColor,
      color: button.textColor
    }
  }, button.label)))));
}
Banner.defaultProps = defaultProps;